"use client";

import { useLingui } from "@lingui/react/macro";
import { PromptInputDisclaimer } from "@/components/ai-elements/prompt-input";
import { cn } from "@/lib/utils";

/** Starter と Composer で共有する注意文の翻訳・改行・表示遷移を描画します。 */
export function ChatPromptDisclaimer({
  show,
  floating,
  placement,
}: {
  show: boolean;
  floating: boolean;
  placement: "before-input" | "after-input";
}) {
  const { t } = useLingui();
  const text = t`Do not enter sensitive information (personal information, passwords, etc.). Submitted content may be used for functional improvement purposes. AI responses may be inaccurate. Please be sure to verify important information yourself.`;
  // 翻訳単位を分割せず、既存カタログを保ったまま広幅時の改行位置だけを特定する。
  const aiResponseSentenceStart = text.indexOf("AI");
  const preamble =
    aiResponseSentenceStart >= 0
      ? text.slice(0, aiResponseSentenceStart)
      : text;
  const aiResponseSentence =
    aiResponseSentenceStart >= 0 ? text.slice(aiResponseSentenceStart) : null;

  return (
    <div
      data-chat-disclaimer-slot
      className={cn(
        "flex min-h-4 items-end justify-center overflow-hidden px-1",
        floating && "absolute inset-x-0 bottom-full mb-2.5",
        // floating 時は input の上へ重なるため、非表示中に上の quota banner などの
        // click を奪わないよう slot 自体も pointer target から外す。
        floating && !show && "pointer-events-none",
        placement === "after-input" && "pt-1",
      )}
    >
      {/* 重なり時は即時退避し、自動スクロールが落ち着いてからだけ再表示する。 */}
      <PromptInputDisclaimer
        className={cn(
          "w-full max-w-4xl text-pretty text-center leading-[1.45]",
          show
            ? "opacity-100 transition-opacity delay-200 duration-150"
            : "pointer-events-none opacity-0 transition-none",
        )}
      >
        {preamble}
        {aiResponseSentence ? (
          <>
            <br aria-hidden className="hidden @4xl:inline" />
            {aiResponseSentence}
          </>
        ) : null}
      </PromptInputDisclaimer>
    </div>
  );
}
